export const GET_AUTOCOMPLETE = 'autocomplete/PRACTICE_RESULTS';
export const AUTOCOMPLETE_FORCE_REFRESH = 'autocomplete/FORCE_REFRESH';



// WEBPACK FOOTER //
// ./src/state/reducers/autocomplete/types.js